<template>
  <StatusDialog
    :visible.sync="dialogVisible"
    type="success"
    @close="onConfirm"
  >
    <h3 class="status-dialog__title">支付成功</h3>
    <p class="status-dialog__desc">{{ descText }}</p>
    <div class="status-dialog__footer">
      <button
        type="button"
        class="status-dialog__btn status-dialog__btn--primary"
        @click="onConfirm"
      >
        我知道了
      </button>
    </div>
  </StatusDialog>
</template>

<script>
export default {
  name: 'PurchaseSuccessDialog',

  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    /** 试用进行中且首次购买：展示「已叠加试用剩余天数」 */
    showTrialTip: {
      type: Boolean,
      default: false,
    },
    /** 正式服务续费或试用预购后再买：展示「已续费」文案 */
    showRenewTip: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    dialogVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit('update:visible', val);
      },
    },

    descText() {
      if (this.showTrialTip) {
        return '您的正式服务已开通，已叠加试用剩余天数';
      }
      if (this.showRenewTip) {
        return '您的正式服务已续费，感谢您的购买';
      }
      return '您的正式服务已开通，感谢您的购买';
    },
  },

  methods: {
    onConfirm() {
      this.dialogVisible = false;
      this.$emit('confirm');
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/view/user/purchaseService/PurchaseSuccessDialog.vue